import { addDays, differenceInHours, differenceInMinutes, intervalToDuration } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { Badge, BadgeVariant } from '@percent/lemonade'
import { TimeLeftProps } from './TimeLeft.types'

export function TimeLeft({ requestedDate }: TimeLeftProps) {
  const { t } = useTranslation()

  if (!requestedDate) return <Badge variant="default">{t('status.na')}</Badge>

  const today = new Date()
  const expectedTimeQuota = addDays(Date.parse(requestedDate), 3)
  const { minutes = 0 } = intervalToDuration({ start: today, end: expectedTimeQuota })
  const hours = differenceInHours(expectedTimeQuota, today)
  const hoursDifference = differenceInMinutes(expectedTimeQuota, today) / 60

  const diffThreeDays = () => {
    const formattedMinutes = Math.abs(minutes).toString().padStart(2, '0')
    const formattedHours = Math.abs(hours)

    if (Math.sign(hours) === -1) {
      return `${formattedHours}h ${formattedMinutes}m past`
    }

    return `${formattedHours}h ${formattedMinutes}m`
  }

  const getVariant = (): BadgeVariant => {
    if (hoursDifference > 36) return 'positive'

    if (hoursDifference <= 36 && hoursDifference >= 24) return 'warning'

    return 'critical'
  }

  return (
    <Badge icon="clock" variant={getVariant()}>
      {diffThreeDays()}
    </Badge>
  )
}
